export const countryCodes = [
  {
    "name": "Afghanistan",
    "code": "AF",
    "dial_code": "+93"
  },
  {
    "name": "Albania",
    "code": "AL",
    "dial_code": "+355"
  },
  {
    "name": "Algeria",
    "code": "DZ",
    "dial_code": "+213"
  },
  {
    "name": "Andorra",
    "code": "AD",
    "dial_code": "+376"
  },
  {
    "name": "Angola",
    "code": "AO",
    "dial_code": "+244"
  },
  {
    "name": "Argentina",
    "code": "AR",
    "dial_code": "+54"
  },
  {
    "name": "Armenia",
    "code": "AM",
    "dial_code": "+374"
  },
  {
    "name": "Australia",
    "code": "AU",
    "dial_code": "+61"
  },
  {
    "name": "Austria",
    "code": "AT",
    "dial_code": "+43"
  },
  {
    "name": "Azerbaijan",
    "code": "AZ",
    "dial_code": "+994"
  },
  {
    "name": "Bahamas",
    "code": "BS",
    "dial_code": "+1 242"
  },
  {
    "name": "Bahrain",
    "code": "BH",
    "dial_code": "+973"
  },
  {
    "name": "Bangladesh",
    "code": "BD",
    "dial_code": "+880"
  },
  {
    "name": "Barbados",
    "code": "BB",
    "dial_code": "+1 246"
  },
  {
    "name": "Belarus",
    "code": "BY",
    "dial_code": "+375"
  },
  {
    "name": "Belgium",
    "code": "BE",
    "dial_code": "+32"
  },
  {
    "name": "Belize",
    "code": "BZ",
    "dial_code": "+501"
  },
  {
    "name": "Benin",
    "code": "BJ",
    "dial_code": "+229"
  },
  {
    "name": "Bhutan",
    "code": "BT",
    "dial_code": "+975"
  },
  {
    "name": "Bolivia",
    "code": "BO",
    "dial_code": "+591"
  },
  {
    "name": "Bosnia and Herzegovina",
    "code": "BA",
    "dial_code": "+387"
  },
  {
    "name": "Botswana",
    "code": "BW",
    "dial_code": "+267"
  },
  {
    "name": "Brazil",
    "code": "BR",
    "dial_code": "+55"
  },
  {
    "name": "Brunei",
    "code": "BN",
    "dial_code": "+673"
  },
  {
    "name": "Bulgaria",
    "code": "BG",
    "dial_code": "+359"
  },
  {
    "name": "Burkina Faso",
    "code": "BF",
    "dial_code": "+226"
  },
  {
    "name": "Burundi",
    "code": "BI",
    "dial_code": "+257"
  },
  {
    "name": "Cambodia",
    "code": "KH",
    "dial_code": "+855"
  },
  {
    "name": "Cameroon",
    "code": "CM",
    "dial_code": "+237"
  },
  {
    "name": "Canada",
    "code": "CA",
    "dial_code": "+1"
  },
  {
    "name": "Chad",
    "code": "TD",
    "dial_code": "+235"
  },
  {
    "name": "Chile",
    "code": "CL",
    "dial_code": "+56"
  },
  {
    "name": "China",
    "code": "CN",
    "dial_code": "+86"
  },
  {
    "name": "Colombia",
    "code": "CO",
    "dial_code": "+57"
  },
  {
    "name": "Costa Rica",
    "code": "CR",
    "dial_code": "+506"
  },
  {
    "name": "Croatia",
    "code": "HR",
    "dial_code": "+385"
  },
  {
    "name": "Cuba",
    "code": "CU",
    "dial_code": "+53"
  },
  {
    "name": "Cyprus",
    "code": "CY",
    "dial_code": "+357"
  },
  {
    "name": "Czech Republic",
    "code": "CZ",
    "dial_code": "+420"
  },
  {
    "name": "Denmark",
    "code": "DK",
    "dial_code": "+45"
  },
  {
    "name": "Dominican Republic",
    "code": "DO",
    "dial_code": "+1 809"
  },
  {
    "name": "Ecuador",
    "code": "EC",
    "dial_code": "+593"
  },
  {
    "name": "Egypt",
    "code": "EG",
    "dial_code": "+20"
  },
  {
    "name": "El Salvador",
    "code": "SV",
    "dial_code": "+503"
  },
  {
    "name": "Estonia",
    "code": "EE",
    "dial_code": "+372"
  },
  {
    "name": "Ethiopia",
    "code": "ET",
    "dial_code": "+251"
  },
  {
    "name": "Finland",
    "code": "FI",
    "dial_code": "+358"
  },
  {
    "name": "France",
    "code": "FR",
    "dial_code": "+33"
  },
  {
    "name": "Germany",
    "code": "DE",
    "dial_code": "+49"
  },
  {
    "name": "Ghana",
    "code": "GH",
    "dial_code": "+233"
  },
  {
    "name": "Greece",
    "code": "GR",
    "dial_code": "+30"
  },
  {
    "name": "India",
    "code": "IN",
    "dial_code": "+91"
  },
  {
    "name": "Indonesia",
    "code": "ID",
    "dial_code": "+62"
  },
  {
    "name": "Iran",
    "code": "IR",
    "dial_code": "+98"
  },
  {
    "name": "Iraq",
    "code": "IQ",
    "dial_code": "+964"
  },
  {
    "name": "Ireland",
    "code": "IE",
    "dial_code": "+353"
  },
  {
    "name": "Israel",
    "code": "IL",
    "dial_code": "+972"
  },
  {
    "name": "Italy",
    "code": "IT",
    "dial_code": "+39"
  },
  {
    "name": "Japan",
    "code": "JP",
    "dial_code": "+81"
  },
  {
    "name": "Kenya",
    "code": "KE",
    "dial_code": "+254"
  },
  {
    "name": "Malaysia",
    "code": "MY",
    "dial_code": "+60"
  },
  {
    "name": "Mexico",
    "code": "MX",
    "dial_code": "+52"
  },
  {
    "name": "Nepal",
    "code": "NP",
    "dial_code": "+977"
  },
  {
    "name": "Netherlands",
    "code": "NL",
    "dial_code": "+31"
  },
  {
    "name": "New Zealand",
    "code": "NZ",
    "dial_code": "+64"
  },
  {
    "name": "Nigeria",
    "code": "NG",
    "dial_code": "+234"
  },
  {
    "name": "Norway",
    "code": "NO",
    "dial_code": "+47"
  },
  {
    "name": "Pakistan",
    "code": "PK",
    "dial_code": "+92"
  },
  {
    "name": "Philippines",
    "code": "PH",
    "dial_code": "+63"
  },
  {
    "name": "Poland",
    "code": "PL",
    "dial_code": "+48"
  },
  {
    "name": "Portugal",
    "code": "PT",
    "dial_code": "+351"
  },
  {
    "name": "Qatar",
    "code": "QA",
    "dial_code": "+974"
  },
  {
    "name": "Romania",
    "code": "RO",
    "dial_code": "+40"
  },
  {
    "name": "Russia",
    "code": "RU",
    "dial_code": "+7"
  },
  {
    "name": "Saudi Arabia",
    "code": "SA",
    "dial_code": "+966"
  },
  {
    "name": "Singapore",
    "code": "SG",
    "dial_code": "+65"
  },
  {
    "name": "South Africa",
    "code": "ZA",
    "dial_code": "+27"
  },
  {
    "name": "South Korea",
    "code": "KR",
    "dial_code": "+82"
  },
  {
    "name": "Spain",
    "code": "ES",
    "dial_code": "+34"
  },
  {
    "name": "Sri Lanka",
    "code": "LK",
    "dial_code": "+94"
  },
  {
    "name": "Sweden",
    "code": "SE",
    "dial_code": "+46"
  },
  {
    "name": "Switzerland",
    "code": "CH",
    "dial_code": "+41"
  },
  {
    "name": "Thailand",
    "code": "TH",
    "dial_code": "+66"
  },
  {
    "name": "Turkey",
    "code": "TR",
    "dial_code": "+90"
  },
  {
    "name": "Ukraine",
    "code": "UA",
    "dial_code": "+380"
  },
  {
    "name": "United Arab Emirates",
    "code": "AE",
    "dial_code": "+971"
  },
  {
    "name": "United Kingdom",
    "code": "GB",
    "dial_code": "+44"
  },
  {
    "name": "United States",
    "code": "US",
    "dial_code": "+1"
  },
  {
    "name": "Vietnam",
    "code": "VN",
    "dial_code": "+84"
  },
  {
    "name": "Zimbabwe",
    "code": "ZW",
    "dial_code": "+263"
  }
];